import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMastercard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 63,
	height: 40,
	viewBox: "0 0 63 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 7.16418C0.5 3.48365 3.48365 0.5 7.16418 0.5H54.9254C58.6059 0.5 61.5896 3.48365 61.5896 7.16418V32.8358C61.5896 36.5163 58.6059 39.5 54.9254 39.5H7.16418C3.48366 39.5 0.5 36.5163 0.5 32.8358V7.16418Z",
			fill: "#000008",
			stroke: "#D6DCE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.5053 12.0853H26.3635V28.5134H35.5053V12.0853Z",
			fill: "#FF5F00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.944 20.2993C26.9426 18.7172 27.3011 17.1554 27.9924 15.7324C28.6838 14.3093 29.6899 13.0621 30.9344 12.0853C29.3932 10.8738 27.5422 10.1204 25.593 9.91123C23.6438 9.70202 21.6751 10.0454 19.9118 10.9022C18.1486 11.759 16.662 13.0946 15.6219 14.7564C14.5818 16.4181 14.0303 18.3389 14.0303 20.2993C14.0303 22.2597 14.5818 24.1806 15.6219 25.8423C16.662 27.504 18.1486 28.8396 19.9118 29.6964C21.6751 30.5532 23.6438 30.8966 25.593 30.6874C27.5422 30.4782 29.3932 29.7248 30.9344 28.5133C29.6899 27.5365 28.6838 26.2894 27.9925 24.8663C27.3011 23.4432 26.9426 21.8815 26.944 20.2993Z",
			fill: "#EB001B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.8381 20.2993C47.8382 22.2597 47.2867 24.1805 46.2467 25.8423C45.2067 27.504 43.7201 28.8396 41.9569 29.6964C40.1937 30.5532 38.225 30.8966 36.2758 30.6874C34.3266 30.4782 32.4757 29.7248 30.9344 28.5133C32.178 27.5356 33.1832 26.2882 33.8745 24.8653C34.5657 23.4425 34.9249 21.8812 34.9249 20.2993C34.9249 18.7174 34.5657 17.1562 33.8745 15.7333C33.1832 14.3104 32.178 13.0631 30.9344 12.0853C32.4757 10.8738 34.3266 10.1204 36.2758 9.91123C38.225 9.70202 40.1937 10.0454 41.9569 10.9022C43.7201 11.759 45.2067 13.0946 46.2467 14.7564C47.2867 16.4181 47.8382 18.339 47.8381 20.2993Z",
			fill: "#F79E1B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.8413 26.7734V26.437H46.977V26.3685H46.6316V26.437H46.7672V26.7734H46.8413ZM47.5119 26.7734V26.3679H47.406L47.2842 26.6468L47.1624 26.3679H47.0565V26.7734H47.1313V26.4675L47.2455 26.7312H47.323L47.4372 26.4668V26.7734H47.5119Z",
			fill: "#F79E1B"
		})
	]
});
export default SvgMastercard;
